import { ActionsUnion, createAction } from "store/helper";

import { RequestAction, createRequestTypes } from "../actions";

import {
  ICheckRecurlyCouponFailurePayload,
  ICheckRecurlyCouponPayload,
  ICheckRecurlyCouponSuccessPayload,
  IConfigureRecurlyFailurePayload,
  IFetchCouponFailurePayload,
  IFetchCouponSuccessPayload,
  IFetchRecurlyCouponPayload,
} from "./interfaces";

export const RECURLY = {
  COUPONS: createRequestTypes("ENTITIES/RECURLY/COUPONS"),
};

export enum RecurlyActionNames {
  CONFIGURE_RECURLY_REQUEST = "ENTITIES/RECURLY/CONFIGURE_RECURLY_REQUEST",
  CONFIGURE_RECURLY_SUCCESS = "ENTITIES/RECURLY/CONFIGURE_RECURLY_SUCCESS",
  CONFIGURE_RECURLY_FAILURE = "ENTITIES/RECURLY/CONFIGURE_RECURLY_FAILURE",
  CHECK_RECURLY_COUPON_REQUEST = "ENTITIES/RECURLY/CHECK_RECURLY_COUPON_REQUEST",
  CHECK_RECURLY_COUPON_SUCCESS = "ENTITIES/RECURLY/CHECK_RECURLY_COUPON_SUCCESS",
  CHECK_RECURLY_COUPON_FAILURE = "ENTITIES/RECURLY/CHECK_RECURLY_COUPON_FAILURE",
  COUPON_REDEEMED = "ENTITIES/RECURLY/COUPON_REDEEMED",
}

export enum RecurlyRequestFetchingSelectorsNames {
  CONFIGURE_RECURLY_REQUEST = "ENTITIES/RECURLY/CONFIGURE_RECURLY_INFO",
  CHECK_RECURLY_COUPON_REQUEST = "ENTITIES/RECURLY/CHECK_RECURLY_COUPON",
  FETCHING_COUPONS_REQUEST = "ENTITIES/RECURLY/COUPONS",
}

export const RecurlyActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  configureRecurly: (payload: any) => createAction(RecurlyActionNames.CONFIGURE_RECURLY_REQUEST, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  configureRecurlySuccess: () => createAction(RecurlyActionNames.CONFIGURE_RECURLY_SUCCESS),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  configureRecurlyFailure: (error: IConfigureRecurlyFailurePayload) =>
    createAction(RecurlyActionNames.CONFIGURE_RECURLY_FAILURE, error),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  checkRecurlyCoupon: (payload: ICheckRecurlyCouponPayload) =>
    createAction(RecurlyActionNames.CHECK_RECURLY_COUPON_REQUEST, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  checkRecurlyCouponSuccess: (payload: ICheckRecurlyCouponSuccessPayload) =>
    createAction(RecurlyActionNames.CHECK_RECURLY_COUPON_SUCCESS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  checkRecurlyCouponFailure: (error: ICheckRecurlyCouponFailurePayload) =>
    createAction(RecurlyActionNames.CHECK_RECURLY_COUPON_FAILURE, error),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchCoupon: (payload: IFetchRecurlyCouponPayload) => createAction(RECURLY.COUPONS[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchCouponSuccess: (payload: IFetchCouponSuccessPayload) =>
    createAction(RECURLY.COUPONS[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchCouponFailure: (payload: IFetchCouponFailurePayload) =>
    createAction(RECURLY.COUPONS[RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  couponRedeemed: () => createAction(RecurlyActionNames.COUPON_REDEEMED),
};

export type RecurlyActionTypes = ActionsUnion<typeof RecurlyActions>;
